/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/
setInterval(function(){
  $('[data-close-button]').click(function(){
    $(this).parent().removeClass('is-active')
    if($(window).width() < 767){
    $(this).parent().removeClass('is-active').hide()
    $('.quick-add-modal__overlay').remove()
    $('body').removeClass('stop-scrolling')
    }
  })
},500)


/* RTN: strip is-active from selector-wrappers inside home product carousels so the theme's mobile fixed-bottom rule never applies */
(function () {
  function stripActive() {
    document.querySelectorAll('.product-grid--mobile-slider .form-quick-add .selector-wrapper.is-active, .product-grid--slider__custom .form-quick-add .selector-wrapper.is-active, .tabs-collections .form-quick-add .selector-wrapper.is-active').forEach(function (el) {
      el.classList.remove('is-active');
      el.style.display = 'none';
    });
  }
  function init() {
    stripActive();
    var obs = new MutationObserver(stripActive);
    document.querySelectorAll('.product-grid-outer, .tabs-collections').forEach(function (n) {
      obs.observe(n, { attributes: true, childList: true, subtree: true, attributeFilter: ['class'] });
    });
    // Re-run periodically in case slick adds them later
    setTimeout(stripActive, 500);
    setTimeout(stripActive, 1500);
    setTimeout(stripActive, 3000);
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
